import { openBlock as t, createElementBlock as e, createElementVNode as l } from "vue";
const h = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ l("path", {
  fill: "#0052B4",
  d: "M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20C0 20.005 20 .002 20 0c11.046 0 20 8.954 20 20Z"
}, null, -1), o = /* @__PURE__ */ l("path", {
  fill: "#F0F0F0",
  d: "M20 0h-.003H20Zm-.054 20H20v-.053l-.054.053ZM20 10.435V0h-.003C8.952.002 0 8.955 0 20h10.435v-5.876L16.31 20h3.635l.054-.053V16.31l-5.876-5.876H20Z"
}, null, -1), c = /* @__PURE__ */ l("path", {
  fill: "#D80027",
  d: "M10.118 2.609a20.095 20.095 0 0 0-7.51 7.51V20h5.218V7.826H20V2.61h-9.882Z"
}, null, -1), s = /* @__PURE__ */ l("path", {
  fill: "#D80027",
  d: "m20 17.54-7.106-7.105h-2.46L20 20v-2.46Zm14.635-2.7.431 1.33h1.397l-1.13.82.432 1.329-1.13-.821-1.13.82.431-1.328-1.13-.82h1.397l.432-1.33Zm-4.994 9.566.648 1.993h2.095L30.69 27.63l.648 1.993-1.696-1.232-1.695 1.232.647-1.993-1.695-1.231h2.096l.647-1.993Zm.189-15.652.54 1.66h1.746l-1.413 1.027.54 1.66-1.413-1.026-1.413 1.026.54-1.66-1.413-1.027h1.746l.54-1.66Zm-4.805 6.029.647 1.993h2.096l-1.695 1.231L26.72 20l-1.695-1.232L23.33 20l.647-1.993-1.695-1.232h2.095l.648-1.992Z"
}, null, -1), d = [
  n,
  o,
  c,
  s
];
function i(_, a) {
  return t(), e("svg", h, [...d]);
}
const m = { render: i };
export {
  m as default,
  i as render
};
